<template>
  <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light collapse sidebar">
    <div class="position-sticky pt-3 sidebar-sticky d-flex flex-column" style="height: 100%;">
      <div style="flex-grow: 1;">
        <hr style="margin:0 rem;">
        <PanelMenu class="nav nav-pills flex-column mb-auto" :model="internalItems">
          <template #item="{ item }">
            <router-link class="nav-link" active-class="active" v-if="item.menuUrl && !/^https?:\/\//.test(item.menuUrl)" v-slot="{ navigate }" :to="item.menuUrl" custom>
              <a v-ripple class="flex align-items-center cursor-pointer text-color px-3 py-2" href="#"
                @click="(event) => { 
                  event.preventDefault();
                  if (item.items) {                    
                  } else {                    
                    navigate(); 
                    handleSubMenuClick(); 
                  }
                }" style="text-decoration: none;" >
                <span v-if="item.items" class="pi pi-angle-right" style="margin-right: 10px; color: #92989d;" />
                <span :class="item.icon" style="margin-right: 10px; color: #92989d;" />
                <span class="ml-2 text-color">
                  <b v-if="item.items">{{ item.menuName }}</b>
                  <template v-else>{{ item.menuName }}</template>
                </span>
              </a>
            </router-link>
          </template>
        </PanelMenu>
      </div>
      <div>
        <PanelMenu class="nav nav-pills flex-column" :model="externalItems">
          <template #item="{ item }">
            <a v-ripple class="flex align-items-center cursor-pointer text-color px-3 py-2" :href="item.menuUrl" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">
              <span v-if="item.items" class="pi pi-angle-right" style="margin-right: 10px; color: #92989d;" />
              <span :class="item.icon" style="margin-right: 10px; color: #92989d;" />
              <span class="ml-2" style="color: #007bff;"><B>{{ item.menuName }}</B></span>
            </a>
          </template>
        </PanelMenu>
      </div>      
    </div>
  </nav>
  </template>
      
  <script>
  import axios from 'axios'
  import { mapGetters } from "vuex"
  var requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      timeout: 60000
    }
  };
  export default {
    name: 'Menu',
    data() {
      return {
        menu: [],
        isMobile : this.$isMobile(),
        items: [],      
        internalItems: [],
        externalItems: [], 
      }
    },
    components: {
    },
    computed: {
      ...mapGetters(["isAuthenticated"]),
      ...mapGetters(["getUserEmail"]),
    },
    created() {
      var paramData = {};
      axios.get(`/biz/common/${this.$store.getters.getUserEmail}/${this.$store.getters.getRole}/menu`, paramData, requestOptions)
        .then((result) => {        
          result.data.mainMenu.forEach(mainMenu => {
              const items = result.data.subMenus.filter(subMenu => subMenu.parentMenuSeq === mainMenu.parentMenuSeq);                 
              if(items.length > 0) {
                mainMenu.items = items;
              }
          });
  
          this.menu = result.data.mainMenu;
          //this.items = this.items = this.menu.slice().sort((a, b) => a.sort - b.sort);
          this.internalItems = this.menu.filter(m => !/^https?:\/\//.test(m.menuUrl)).sort((a, b) => a.sort - b.sort);
          this.externalItems = this.menu.filter(m => /^https?:\/\//.test(m.menuUrl)).sort((a, b) => a.sort - b.sort);

        })
    },
    mounted(){
      this.onResize();
      window.addEventListener('resize',this.onResize,{passive:true});
    },
    beforeDestory(){
      if(typeof window === 'undefined') return;
      window.removeEventListener('resize',this.onResize,{passive:true});
    },
    methods: {
      topMenuButtonClick(){
        if(this.isMobile){
          document.querySelector('#topMenuButton').click();
        }
      },
      onResize(){
        this.isMobile = window.innerWidth < 600
      },
      handleSubMenuClick() {
        if (this.isMobile) {
          document.getElementById("topMenuButton").click();
        }
      },
    },
  }
  </script>
  
  
      
  <style scoped>   
    hr{
      margin-top: 0;
    }   
    a {
      color:black;
      display:flex;      
    }    
    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content{
      border:0px solid;
    }
    .sidebar {
      min-height: 100vh;
      padding-bottom: 1rem;
    }
  
  @import './sidebars.css';
  </style>